module.exports = __webpack_public_path__ + "b49645fdef7491951e9acf707407c32b.pdf";